import { createFileRoute, Link } from '@tanstack/react-router'
import { Card, CardDescription, CardHeader, CardTitle } from '#/components/ui/card'
import { MessageSquare, Home, Settings, UserCheck, FileText, Megaphone } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$slug/')({
  component: DashboardPage,
})

function DashboardPage() {
  const { slug } = Route.useParams()

  const quickLinks = [
    { to: '/$slug/lobby' as const, label: 'Lobby', icon: MessageSquare, description: 'Doorperson dashboard' },
    { to: '/$slug/messages' as const, label: 'Messages', icon: MessageSquare, description: 'View conversations' },
    { to: '/$slug/broadcasts' as const, label: 'Broadcasts', icon: Megaphone, description: 'Send an SMS to a whole segment' },
    { to: '/$slug/settings/contacts' as const, label: 'Contacts', icon: UserCheck, description: 'Manage residents and contacts' },
    { to: '/$slug/settings/properties' as const, label: 'Properties', icon: Home, description: 'Manage properties and units' },
    { to: '/$slug/settings/templates' as const, label: 'Templates', icon: FileText, description: 'Message templates' },
    { to: '/$slug/settings/organization' as const, label: 'Settings', icon: Settings, description: 'Organization settings' },
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Organization Dashboard</h1>
        <p className="text-muted-foreground mt-2">Select a section to get started</p>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {quickLinks.map((link) => {
          const Icon = link.icon
          return (
            <Link key={link.to} to={link.to} params={{ slug }}>
              <Card className="hover:bg-accent transition-colors cursor-pointer h-full">
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-primary/10">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                    <CardTitle className="text-lg">{link.label}</CardTitle>
                  </div>
                  <CardDescription>{link.description}</CardDescription>
                </CardHeader>
              </Card>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
